<template>
    <div class="editar-varias-cuentas-scope">
        <md-dialog :md-active.sync="showEditMasivo" :md-click-outside-to-close="false">
            <md-dialog-title class="dialog-header">
                <span class="header-title">{{ labels.title }}</span>
            </md-dialog-title>

            <md-dialog-content class="dialog-content">
                <div class="form-container">
                    <!-- Criterios de búsqueda -->
                    <div class="form-group">
                        <div class="form-field">
                            <label class="field-label">{{ labels.criterio }} (Cuenta)</label>
                            <md-field>
                                <md-input v-model="critCuenta" @input="buscaCuenta" placeholder="Buscar cuenta..." />
                            </md-field>
                        </div>
                        <div class="form-field">
                            <label class="field-label">{{ labels.criterio }} (Descripción)</label>
                            <md-field>
                                <md-input v-model="critDescripcion" @input="buscaDescripcion"
                                    placeholder="Buscar descripción..." />
                            </md-field>
                        </div>
                    </div>

                    <!-- Selección múltiple de cuentas -->
                    <div class="form-field-full">
                        <label class="field-label">{{ labels.cuenta }}</label>
                        <div class="multiselect-container">
                            <div class="multiselect-header">
                                <md-checkbox v-model="selectAll" @change="toggleSelectAll">
                                    {{ selectAll ? labels.deselectAll : labels.selectAll }}
                                </md-checkbox>
                                <span class="selected-count">{{ listCuentasSel.length }} {{ labels.selected }}</span>
                            </div>
                            <div class="multiselect-list">
                                <div v-for="cuenta in listCuentas" :key="cuenta.id" class="multiselect-item">
                                    <md-checkbox v-model="listCuentasSel" :value="cuenta.cuenta"
                                        class="account-checkbox">
                                        {{ cuenta.cuenta }} - {{ cuenta.descripcion }}
                                    </md-checkbox>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Selector de campo a modificar -->
                    <div class="form-field-full">
                        <label class="field-label">Campo a modificar</label>
                        <md-field>
                            <select v-model="campoAModificar" class="modern-select" @change="resetCampos">
                                <option value="" disabled>{{ labels.sel }}</option>
                                <option value="niif">{{ labels.niif }}</option>
                                <option value="booleanos">{{ labels.esf }}/{{ labels.eri }}/{{ labels.efe }}/{{
                                    labels.ecp }}</option>
                                <option value="interco">{{ labels.interco }}</option>
                            </select>
                        </md-field>
                    </div>

                    <!-- Niif - Solo visible cuando se selecciona -->
                    <div class="form-field-full" v-if="campoAModificar === 'niif'">
                        <label class="field-label">{{ labels.niif }}</label>
                        <md-field>
                            <select v-model="niifSel" class="modern-select">
                                <option value="" disabled>{{ labels.sel }}</option>
                                <option v-for="planCons in listNiif" :key="planCons.id" :value="planCons.niif">
                                    {{ planCons.niif }}-{{ planCons.nameNiif }}
                                </option>
                            </select>
                        </md-field>
                    </div>

                    <!-- Opciones booleanas - Solo visibles cuando se selecciona -->
                    <div class="boolean-options" v-if="campoAModificar === 'booleanos'">
                        <div class="boolean-group">
                            <div class="boolean-field">
                                <label class="boolean-label">{{ labels.esf }}</label>
                                <select v-model="esf" class="boolean-select">
                                    <option value="">{{ labels.not }}</option>
                                    <option value="1">{{ labels.yes }}</option>
                                </select>
                            </div>
                            <div class="boolean-field">
                                <label class="boolean-label">{{ labels.eri }}</label>
                                <select v-model="eri" class="boolean-select">
                                    <option value="">{{ labels.not }}</option>
                                    <option value="1">{{ labels.yes }}</option>
                                </select>
                            </div>
                        </div>
                        <div class="boolean-group">
                            <div class="boolean-field">
                                <label class="boolean-label">{{ labels.efe }}</label>
                                <select v-model="efe" class="boolean-select">
                                    <option value="">{{ labels.not }}</option>
                                    <option value="1">{{ labels.yes }}</option>
                                </select>
                            </div>
                            <div class="boolean-field">
                                <label class="boolean-label">{{ labels.ecp }}</label>
                                <select v-model="ecp" class="boolean-select">
                                    <option value="">{{ labels.not }}</option>
                                    <option value="1">{{ labels.yes }}</option>
                                </select>
                            </div>
                        </div>
                    </div>

                    <!-- Interco - Solo visible cuando se selecciona -->
                    <div class="form-field-full" v-if="campoAModificar === 'interco'">
                        <label class="field-label">{{ labels.interco }}</label>
                        <md-field>
                            <select v-model="interco" class="modern-select">
                                <option value="">{{ labels.noGroup }}</option>
                                <option v-for="grupo in gruposInterco" :key="grupo.interco" :value="grupo.interco">
                                    {{ grupo.descripcion }}
                                </option>
                            </select>
                        </md-field>
                    </div>

                    <!-- Información del campo seleccionado -->
                    <div class="info-box" v-if="campoAModificar && listCuentasSel.length > 0">
                        <div class="info-icon">ℹ️</div>
                        <div class="info-text">
                            <strong>Modificación:</strong>
                            <span v-if="campoAModificar === 'niif'">
                                Se actualizará el NIIF a "{{ getNiifName(niifSel) }}" para {{ listCuentasSel.length }}
                                cuenta(s)
                            </span>
                            <span v-else-if="campoAModificar === 'booleanos'">
                                Se actualizarán los campos booleanos para {{ listCuentasSel.length }} cuenta(s)
                            </span>
                            <span v-else-if="campoAModificar === 'interco'">
                                Se actualizará el Interco a "{{ getIntercoName(interco) }}" para {{
                                listCuentasSel.length }} cuenta(s)
                            </span>
                        </div>
                    </div>
                </div>
            </md-dialog-content>

            <md-dialog-actions class="dialog-actions">
                <md-button class="cancel-btn" @click="closeDialog">
                    {{ labels.close }}
                </md-button>
                <md-button class="save-btn" @click="confirmSave" :disabled="isSaving || !campoAModificar">
                    {{ isSaving ? labels.saving : labels.save }}
                </md-button>
            </md-dialog-actions>
        </md-dialog>
    </div>
</template>

<style scoped>
/* Header del diálogo */
.dialog-header {
    background: #34495e;
    color: white;
    padding: 20px 24px;
    margin: 0;
    border-bottom: 1px solid #2c3e50;
}

.header-title {
    font-size: 1.3rem;
    font-weight: 500;
}

.dialog-content {
    min-height: 500px;
}

/* Diálogo específico para EditaVariasCuentas */
.container .md-dialog {
    width: 800px !important;
    min-width: 800px !important;
    max-width: 800px !important;
    height: 650px !important;
    min-height: 650px !important;
    max-height: 650px !important;
    position: fixed !important;
    top: 50% !important;
    left: 50% !important;
    transform: translate(-50%, -50%) !important;
}

/* Asegura que el contenido ocupe todo el espacio */
.dialog-content {
    height: 100%;
    padding: 20px 24px;
}

.form-container {
    height: 100%;
    display: flex;
    flex-direction: column;
}

/* Grupos de formulario */
.form-group {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 20px;
    margin-bottom: 20px;
}

.form-field-full {
    margin-bottom: 20px;
}

/* Labels y campos */
.field-label {
    display: block;
    font-weight: 600;
    color: #2c3e50;
    margin-bottom: 8px;
    font-size: 14px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

/* Campos de formulario */
.modern-select {
    width: 100%;
    padding: 12px 16px;
    border: 1px solid #bdc3c7;
    border-radius: 4px;
    background: white;
    font-size: 14px;
    color: #2c3e50;
    outline: none;
    transition: border-color 0.2s ease;
}

.modern-select:focus {
    border-color: #3498db;
    box-shadow: 0 0 0 2px rgba(52, 152, 219, 0.1);
}

/* Opciones booleanas */
.boolean-options {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 20px;
    margin-bottom: 20px;
    padding: 20px;
    background: #f8f9fa;
    border-radius: 6px;
    border: 1px solid #e9ecef;
}

.boolean-group {
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.boolean-field {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.boolean-label {
    font-weight: 500;
    color: #2c3e50;
    font-size: 14px;
    min-width: 60px;
}

.boolean-select {
    padding: 8px 12px;
    border: 1px solid #bdc3c7;
    border-radius: 4px;
    background: white;
    font-size: 14px;
    color: #2c3e50;
    outline: none;
    min-width: 80px;
    text-align: center;
}

.boolean-select:focus {
    border-color: #3498db;
}

/* Acciones del diálogo */
.dialog-actions {
    padding: 20px 24px;
    border-top: 1px solid #ecf0f1;
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    background: #f8f9fa;
}

.cancel-btn {
    background: #95a5a6 !important;
    color: white !important;
    font-size: 14px;
    padding: 10px 24px;
    min-width: 100px;
}

.save-btn {
    background: #3498db !important;
    color: white !important;
    font-size: 14px;
    padding: 10px 24px;
    min-width: 100px;
}

.save-btn:disabled {
    background: #bdc3c7 !important;
    cursor: not-allowed;
}

.cancel-btn:hover {
    background: #7f8c8d !important;
}

.save-btn:hover:not(:disabled) {
    background: #2980b9 !important;
}

/* Responsive */
@media (max-width: 768px) {
    .form-group {
        grid-template-columns: 1fr;
        gap: 16px;
    }

    .boolean-options {
        grid-template-columns: 1fr;
        gap: 16px;
    }

    .form-container {
        padding: 16px;
    }

    .dialog-actions {
        padding: 16px;
    }
}

/* Estilos específicos para el selector múltiple */
.multiselect-container {
    border: 1px solid #e0e0e0;
    border-radius: 4px;
    overflow: hidden;
    min-height: 200px;
}

.multiselect-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1px 12px;
    background-color: #f9f9f9;
    border-bottom: 1px solid #e0e0e0;
}

.selected-count {
    font-size: 0.875rem;
    color: #666;
}

.multiselect-list {
    max-height: 250px;
    overflow-y: auto;
    min-height: 150px;
}

.multiselect-item {
    padding: 0px 12px;
    border-bottom: 1px solid #f0f0f0;
    min-height: 18px;
    line-height: 1.1;
    font-size: 0.9rem;
}

.multiselect-item:last-child {
    border-bottom: none;
}

.account-checkbox {
    margin: 0;
    padding: 0;
    line-height: 1.2;
}

/* Información box */
.info-box {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    padding: 16px;
    background: #e3f2fd;
    border: 1px solid #2196f3;
    border-radius: 6px;
    margin-top: 20px;
}

.info-icon {
    font-size: 18px;
    flex-shrink: 0;
}

.info-text {
    color: #1565c0;
    font-size: 14px;
    line-height: 1.4;
}
</style>

<script>
import PlanCuentas from '../../services/PlanCuentas';
import GruposIntercos from '../../services/GruposIntercos'

export default {
    name: "EditaVariasCuentas",
    props: ['showEditMasivo', 'compVigSelect', 'listadoCuentas', 'listadoNiif'],
    data: () => ({
        listCuentasSel: [],
        campoAModificar: "", // 'niif', 'booleanos', 'interco'
        niifSel: "",
        esf: null,
        eri: null,
        efe: null,
        ecp: null,
        interco: "",
        critCuenta: "",
        listCuentas: [],
        listNiif: [],
        critDescripcion: "",
        selectAll: false,
        isSaving: false,
        hasUnsavedChanges: false,
        gruposInterco: [],
    }),
    computed: {
        labels() {
            if (this.$store.state._language == "es-ES") {
                return {
                    title: "Editar cuentas masivamente",
                    save: "Guardar",
                    saving: "Guardando...",
                    close: "Cerrar",
                    levelFirst: "Primer nivel:",
                    levelSecond: "Segundo nivel:",
                    cuenta: "Cuentas:",
                    name: "Nombre:",
                    niif: "Niif:",
                    esf: "Esf:",
                    eri: "Eri:",
                    efe: "Efe:",
                    ecp: "Ecp:",
                    interco: "Interco:",
                    sel: "Seleccione...",
                    yes: "SI",
                    not: "NO",
                    criterio: "Criterio:",
                    selectAll: "Seleccionar todo",
                    deselectAll: "Deseleccionar todo",
                    selected: "seleccionadas",
                    noGroup: "NO",
                }
            } else {
                return {
                    title: "Mass Edit Accounts",
                    save: "Save",
                    saving: "Saving...",
                    close: "Close",
                    levelFirst: "First level:",
                    levelSecond: "Second level:",
                    cuenta: "Accounts:",
                    name: "Name:",
                    niif: "Niif:",
                    esf: "Esf:",
                    eri: "Eri:",
                    efe: "Efe:",
                    ecp: "Ecp:",
                    interco: "Interco:",
                    sel: "Select...",
                    yes: "Yes",
                    not: "No",
                    criterio: "Criterion:",
                    selectAll: "Select all",
                    deselectAll: "Deselect all",
                    selected: "selected",
                    noGroup: "NO",
                }
            }
        }
    },
    watch: {
        showEditMasivo(val) {
            if (val == true) {
                this.listCuentas = this.listadoCuentas;
                this.listNiif = this.listadoNiif;
                this.hasUnsavedChanges = false;
                this.loadGruposInterco().then(() => {
                });
            }
        },
        listCuentasSel: {
            handler() {
                this.updateSelectAllState();
                this.hasUnsavedChanges = true;
            },
            deep: true
        },
        campoAModificar() {
            this.hasUnsavedChanges = true;
        },
        niifSel() {
            this.hasUnsavedChanges = true;
        },
        esf() {
            this.hasUnsavedChanges = true;
        },
        eri() {
            this.hasUnsavedChanges = true;
        },
        efe() {
            this.hasUnsavedChanges = true;
        },
        ecp() {
            this.hasUnsavedChanges = true;
        },
        interco() {
            this.hasUnsavedChanges = true;
        }
    },
    methods: {
        confirmSave() {
            if (this.listCuentasSel.length === 0) {
                this.$toast.error(this.$store.state._language == "es-ES"
                    ? "Debe seleccionar al menos una cuenta"
                    : "You must select at least one account");
                return;
            }

            if (!this.campoAModificar) {
                this.$toast.error(this.$store.state._language == "es-ES"
                    ? "Debe seleccionar un campo a modificar"
                    : "You must select a field to modify");
                return;
            }

            // Validaciones específicas por campo
            if (this.campoAModificar === 'niif' && !this.niifSel) {
                this.$toast.error(this.$store.state._language == "es-ES"
                    ? "Debe seleccionar un valor para NIIF"
                    : "You must select a value for NIIF");
                return;
            }

            // Para interco, el valor "" (NO) es válido, solo rechazamos undefined
            if (this.campoAModificar === 'interco' && this.interco === undefined) {
                this.$toast.error(this.$store.state._language == "es-ES"
                    ? "Debe seleccionar un valor para Interco"
                    : "You must select a value for Interco");
                return;
            }

            const message = this.$store.state._language == "es-ES"
                ? `¿Está seguro que desea modificar ${this.getCampoNombre()} para ${this.listCuentasSel.length} cuenta(s)?`
                : `Are you sure you want to modify ${this.getCampoNombre()} for ${this.listCuentasSel.length} account(s)?`;

            if (window.confirm(message)) {
                this.editPlanCuenta();
            }
        },

        getCampoNombre() {
            switch (this.campoAModificar) {
                case 'niif': return this.labels.niif;
                case 'booleanos': return `${this.labels.esf}/${this.labels.eri}/${this.labels.efe}/${this.labels.ecp}`;
                case 'interco': return this.labels.interco;
                default: return '';
            }
        },

        editPlanCuenta() {
            this.isSaving = true;

            // Preparar los datos base
            let datos = {
                'listCuentas': this.listCuentasSel,
                'vigencia': this.compVigSelect.vigencia,
                'companyId': this.compVigSelect.companyId,
                'codReporte': this.compVigSelect.codReporte
            }

            // Agregar SOLO el campo específico que queremos modificar
            switch (this.campoAModificar) {
                case 'niif':
                    datos.niif = this.niifSel;
                    break;

                case 'booleanos':
                    // IMPORTANTE: Incluir los campos incluso cuando son vacíos ("") para "NO"
                    datos.esf = this.esf;
                    datos.eri = this.eri;
                    datos.efe = this.efe;
                    datos.ecp = this.ecp;
                    break;

                case 'interco':
                    datos.interco = this.interco === '' ? null : this.interco;
                    break;
            }

            // Validar que al menos un campo fue modificado
            // Considerar valores vacíos como cambios válidos (para "NO" en booleanos e interco)
            const camposModificados = Object.keys(datos).filter(key =>
                !['listCuentas', 'vigencia', 'companyId', 'codReporte'].includes(key)
            );

            // Para booleanos, verificar que al menos uno tenga un valor definido (incluyendo "")
            if (this.campoAModificar === 'booleanos') {
                const hayCambiosBooleanos = ['esf', 'eri', 'efe', 'ecp'].some(campo =>
                    datos[campo] !== null && datos[campo] !== undefined
                );

                if (!hayCambiosBooleanos) {
                    this.$toast.error(this.$store.state._language == "es-ES"
                        ? "Debe modificar al menos un campo booleano"
                        : "You must modify at least one boolean field");
                    this.isSaving = false;
                    return;
                }
            }
            // Para interco, el valor "" (NO) es un cambio válido - solo verificamos que esté presente
            else if (this.campoAModificar === 'interco') {
                // El valor "" es válido para "NO", y cualquier otro valor también
                // No necesita validación adicional aquí ya que el campo está presente en datos
            }
            else if (camposModificados.length === 0) {
                this.$toast.error(this.$store.state._language == "es-ES"
                    ? "Debe modificar al menos un campo"
                    : "You must modify at least one field");
                this.isSaving = false;
                return;
            }

            console.log("Datos enviados al backend:", datos);

            PlanCuentas.planCuentasMassiveUpdate(datos)
                .then((res) => {
                    console.log("Respuesta completa del backend:", res);
                    if (res.status == 200) {
                        this.$toast.success(res.data.message);
                        this.hasUnsavedChanges = false;

                        setTimeout(() => {
                            this.reloadTbl();
                        }, 2000);
                    }
                })
                .catch((err) => {
                    console.log("Error completo:", err);
                    console.log("Error response:", err.response);
                    this.$toast.error(this.$store.state._language == "es-ES"
                        ? "Error al actualizar las cuentas"
                        : "Error updating accounts");
                    this.isSaving = false;
                })
        },

        getNiifName(niifValue) {
            const niif = this.listNiif.find(n => n.niif === niifValue);
            return niif ? `${niif.niif}-${niif.nameNiif}` : '';
        },

        getIntercoName(intercoValue) {
            if (intercoValue === '') return this.labels.noGroup;
            const grupo = this.gruposInterco.find(g => g.interco === intercoValue);
            return grupo ? grupo.descripcion : '';
        },

        resetCampos() {
            // Resetear todos los campos cuando se cambia la selección
            this.niifSel = "";
            this.esf = null;
            this.eri = null;
            this.efe = null;
            this.ecp = null;
            this.interco = "";
        },

        reloadTbl() {
            this.$emit('reload', this.compVigSelect.vigencia, this.compVigSelect.companyId, this.compVigSelect.codReporte);
            this.clearCampos();
            this.$emit('clicked', false);
        },

        clearCampos() {
            this.listCuentasSel = [];
            this.campoAModificar = "";
            this.niifSel = "";
            this.esf = null;
            this.eri = null;
            this.efe = null;
            this.ecp = null;
            this.interco = "";
            this.critCuenta = "";
            this.critDescripcion = "";
            this.selectAll = false;
            this.isSaving = false;
            this.hasUnsavedChanges = false;
        },

        buscaCuenta() {
            const criterio = "^" + this.critCuenta;
            if (this.critCuenta.length == 0) {
                this.listCuentas = this.listadoCuentas;
            } else {
                this.listCuentas = this.listadoCuentas.filter(
                    (cuenta) => cuenta.cuenta.match(criterio) > 0);
            }
            this.updateSelectAllState();
        },

        buscaDescripcion() {
            if (this.critDescripcion.length == 0) {
                this.listCuentas = this.listadoCuentas;
            } else {
                this.listCuentas = this.listadoCuentas.filter(
                    (cuenta) => cuenta.descripcion.toUpperCase().indexOf(this.critDescripcion.toUpperCase()) >= 0);
            }
            this.updateSelectAllState();
        },

        toggleSelectAll() {
            if (this.selectAll) {
                // Seleccionar todas las cuentas visibles
                this.listCuentasSel = this.listCuentas.map(cuenta => cuenta.cuenta);
            } else {
                // Deseleccionar todas
                this.listCuentasSel = [];
            }
        },

        updateSelectAllState() {
            if (this.listCuentas.length === 0) {
                this.selectAll = false;
                return;
            }

            // Verificar si todas las cuentas visibles están seleccionadas
            const allSelected = this.listCuentas.every(cuenta =>
                this.listCuentasSel.includes(cuenta.cuenta));

            this.selectAll = allSelected;
        },

        async loadGruposInterco() {
            try {
                const res = await GruposIntercos.getAllGruposIntercos();
                this.gruposInterco = res.data.gruposIntercos || [];
                return this.gruposInterco;
            } catch (err) {
                console.error("Error loading grupos interco:", err);
                this.gruposInterco = [];
                return [];
            }
        },

        closeDialog() {
            if (this.hasUnsavedChanges) {
                const message = this.$store.state._language == "es-ES"
                    ? "Tienes cambios sin guardar. ¿Quieres cerrar sin guardar?"
                    : "You have unsaved changes. Do you want to close without saving?";

                if (window.confirm(message)) {
                    this.clearCampos();
                    this.$emit('clicked', false);
                }
            } else {
                this.clearCampos();
                this.$emit('clicked', false);
            }
        }
    }
}
</script>
<style src="../main.css"></style>